// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-companyRankings .rDNA-rankingsTitle {
  font-family: "Dm Sans", sans-serif;
  font-size: 34px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-companyRankings .rDNA-rankingEntry {
  font-family: "Dm Sans", sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
}

.rDNA-companyRankings .rDNA-rankingsColHeader {
  font-family: "Dm Sans", sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-companyRankings .rDNA-rankingCard {
  height: 100%;
  width: 100%;
}

.rDNA-companyRankings .outer-circle, .rDNA-companyRankings .rDNA-iconContainer {
  display: flex;
  flex-direction: row;
}

.rDNA-companyRankings .outer-circle {
  justify-content: center;
  align-items: center;
}

.rDNA-companyRankings .rDNA-iconContainer {
  justify-content: flex-start;
  align-items: center;
}

.rDNA-companyRankings {
  height: 100%;
  width: 100%;
}
.rDNA-companyRankings .decreasing {
  background-color: #FF0000;
}
.rDNA-companyRankings .increasing {
  background-color: #00B300;
}
.rDNA-companyRankings .noMovement {
  background-color: #FFBF00;
}
.rDNA-companyRankings .newEntry {
  background-color: #0CAD99;
}
.rDNA-companyRankings .rDNA-contentWrapper {
  padding: 0;
}
.rDNA-companyRankings .rDNA-movementTxt {
  margin-left: 10px;
}
.rDNA-companyRankings .rDNA-iconContainer {
  position: relative;
  left: 15%;
  width: 100%;
}
.rDNA-companyRankings .outer-circle {
  border-radius: 50%;
  color: #fff;
}
.rDNA-companyRankings .outer-circle fa-icon {
  font-size: 28px;
}
.rDNA-companyRankings .rDNA-rankingCard {
  justify-content: center;
  box-shadow: none;
  border-radius: 20px;
}
.rDNA-companyRankings .rDNA-rankingsColHeader {
  color: #A3AED0;
}
.rDNA-companyRankings .rDNA-rankingEntry {
  color: #1B3E78;
}
.rDNA-companyRankings .rDNA-rankingsTitle {
  color: #1B3E78;
}
.rDNA-companyRankings .rDNA-txtCtrlWrapper {
  width: 100%;
}
.rDNA-companyRankings .rDNA-txtCtrlWrapper .rDNA-txtCtrlWrapper {
  align-items: center;
}

@media screen and (max-width: 767.7px) {
  .rDNA-companyRankings {
    margin-bottom: 10px;
  }
  .rDNA-companyRankings .rDNA-rankingCard {
    padding: 5px 15px;
  }
  .rDNA-companyRankings .rDNA-txtCtrlWrapper {
    padding-left: 5px;
  }
  .rDNA-companyRankings .rDNA-rankingsColHeader {
    font-size: 12px;
  }
  .rDNA-companyRankings .rDNA-rankingEntry {
    font-size: 12px;
  }
  .rDNA-companyRankings .rDNA-rankingsTitle {
    font-size: 18px;
  }
  .rDNA-companyRankings .outer-circle {
    width: 15px;
    height: 15px;
  }
  .rDNA-companyRankings .outer-circle fa-icon {
    font-size: 15px;
  }
  .rDNA-companyRankings .outer-circle .icon-newEntry {
    font-size: 9px;
  }
}
@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-companyRankings .rDNA-rankingCard {
    padding: 5px;
  }
  .rDNA-companyRankings .rDNA-movementTxt {
    margin-left: 5px;
  }
  .rDNA-companyRankings .rDNA-txtCtrlWrapper {
    padding-left: 5px;
  }
  .rDNA-companyRankings .rDNA-rankingsColHeader {
    font-size: 10px;
  }
  .rDNA-companyRankings .rDNA-rankingEntry {
    font-size: 8px;
  }
  .rDNA-companyRankings .rDNA-rankingsTitle {
    font-size: 18px;
  }
  .rDNA-companyRankings .outer-circle {
    width: 15px;
    height: 15px;
  }
  .rDNA-companyRankings .outer-circle fa-icon {
    font-size: 15px;
  }
  .rDNA-companyRankings .outer-circle .icon-newEntry {
    font-size: 10px;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-companyRankings .rDNA-movementTxt {
    margin-left: 5px;
  }
  .rDNA-companyRankings .rDNA-rankingCard {
    padding: 10px;
  }
  .rDNA-companyRankings .rDNA-txtCtrlWrapper {
    padding-left: 10px;
  }
  .rDNA-companyRankings .rDNA-rankingsColHeader {
    font-size: 12px;
  }
  .rDNA-companyRankings .rDNA-rankingEntry {
    font-size: 12px;
  }
  .rDNA-companyRankings .rDNA-rankingsTitle {
    font-size: 20px;
  }
  .rDNA-companyRankings .outer-circle {
    width: 17px;
    height: 17px;
  }
  .rDNA-companyRankings .outer-circle fa-icon {
    font-size: 16px;
  }
  .rDNA-companyRankings .outer-circle .icon-newEntry {
    font-size: 10px;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-companyRankings .rDNA-rankingCard {
    padding: 15px;
  }
  .rDNA-companyRankings .rDNA-txtCtrlWrapper {
    padding-left: 20px;
  }
  .rDNA-companyRankings .rDNA-rankingsColHeader {
    font-size: 14px;
  }
  .rDNA-companyRankings .rDNA-rankingEntry {
    font-size: 14px;
  }
  .rDNA-companyRankings .rDNA-rankingsTitle {
    font-size: 20px;
  }
  .rDNA-companyRankings .outer-circle {
    width: 20px;
    height: 20px;
  }
  .rDNA-companyRankings .outer-circle fa-icon {
    font-size: 20px;
  }
  .rDNA-companyRankings .outer-circle .icon-newEntry {
    font-size: 14px;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-companyRankings .rDNA-rankingCard {
    padding: 25px;
  }
  .rDNA-companyRankings .rDNA-txtCtrlWrapper {
    padding-left: 50px;
  }
  .rDNA-companyRankings .rDNA-rankingsColHeader {
    font-size: 18px;
  }
  .rDNA-companyRankings .rDNA-rankingEntry {
    font-size: 20px;
  }
  .rDNA-companyRankings .rDNA-rankingsTitle {
    font-size: 34px;
  }
  .rDNA-companyRankings .outer-circle {
    width: 30px;
    height: 30px;
  }
  .rDNA-companyRankings .outer-circle fa-icon {
    font-size: 28px;
  }
  .rDNA-companyRankings .outer-circle .icon-newEntry {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/profiles/dashboard/elements/rankings/rankings.component.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_quickStyles.scss","webpack://./src/theme/placeholders/_flexboxes.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;AFPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACmHF;ADhHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACkHF;AD/GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACiHF;AD9GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACgHF;AD7GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AC+GF;AD5GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AC8GF;AD3GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;AC6GF;AD1GA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AC4GF;ADzGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AC2GF;ADxGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AC0GF;ADvGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACyGF;ADtGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACwGF;ADrGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACuGF;ADpGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACsGF;ADnGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACqGF;ADlGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACoGF;ADjGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACmGF;ADhGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACkGF;ACtNA;;;;;uBAAA;ACOA;ECEE,kCFXY;EEYZ,eDH2C;ECI3C,gBATiF;EAUjF,kBALgB;AH2NlB;;AE3MA;ECdE,kCFXY;EEYZ,eDa2C;ECZ3C,gBAVgJ;EAWhJ,kBALgB;AHkOlB;;AEzMA;ECvBE,kCFXY;EEYZ,eDsB2C;ECrB3C,gBAXqF;EAYrF,kBALgB;AHyOlB;;AItPA;EACE,YAAA;EACA,WAAA;AJyPF;;AKtPA;EAC0B,aAAA;EACA,mBAAA;ALyP1B;;AKtPA;EAC0B,uBAAA;EACA,mBAAA;ALyP1B;;AK5OA;EAC0B,2BAAA;EACA,mBAAA;AL+O1B;;AArQA;EACoC,YAAA;EACA,WAAA;AAwQpC;AAtQE;EAAoC,yBCqBzB;ADoPb;AAxQE;EAAoC,yBCmBvB;ADwPf;AA1QE;EAAmC,yBCoBtB;ADyPf;AA5QE;EAAmC,yBCCxB;AD8Qb;AA9QE;EAAoC,UAAA;AAiRtC;AAhRE;EAAoC,iBAAA;AAmRtC;AAjRE;EACoC,kBAAA;EACA,SAAA;EACA,WAAA;AAmRtC;AA/QE;EACoC,kBAAA;EACA,WAAA;AAiRtC;AA7QsC;EAAU,eAAA;AAgRhD;AA9QE;EACoC,uBAAA;EAEA,gBAAA;EACA,mBAAA;AA+QtC;AA7QE;EAEoC,cCvBtB;ADqShB;AA5QE;EAEoC,cC7B1B;AD0SZ;AA3QE;EAEoC,cCjC1B;AD6SZ;AA1QE;EACoC,WAAA;AA4QtC;AA3QsC;EACE,mBAAA;AA6QxC;;AAxQA;EACE;IACsC,mBAAA;EA2QtC;EA1QE;IAAoC,iBAAA;EA6QtC;EA5QE;IAAoC,iBAAA;EA+QtC;EA9QE;IAAoC,eAAA;EAiRtC;EAhRE;IAAoC,eAAA;EAmRtC;EAlRE;IAAoC,eAAA;EAqRtC;EApRE;IACoC,WAAA;IACA,YAAA;EAsRtC;EArRsC;IAAU,eAAA;EAwRhD;EAvRsC;IAAiB,cAAA;EA0RvD;AACF;AAtRA;EAEI;IAAoC,YAAA;EAwRtC;EAvRE;IAAoC,gBAAA;EA0RtC;EAzRE;IAAoC,iBAAA;EA4RtC;EA3RE;IAAoC,eAAA;EA8RtC;EA7RE;IAAoC,cAAA;EAgStC;EA/RE;IAAoC,eAAA;EAkStC;EAjSE;IACoC,WAAA;IACA,YAAA;EAmStC;EAlSsC;IAAU,eAAA;EAqShD;EApSsC;IAAiB,eAAA;EAuSvD;AACF;AApSA;EAEI;IAAoC,gBAAA;EAsStC;EArSE;IAAoC,aAAA;EAwStC;EAvSE;IAAoC,kBAAA;EA0StC;EAzSE;IAAoC,eAAA;EA4StC;EA3SE;IAAoC,eAAA;EA8StC;EA7SE;IAAoC,eAAA;EAgTtC;EA/SE;IACoC,WAAA;IACA,YAAA;EAiTtC;EAhTsC;IAAU,eAAA;EAmThD;EAlTsC;IAAiB,eAAA;EAqTvD;AACF;AAjTA;EAEI;IAAoC,aAAA;EAmTtC;EAlTE;IAAoC,kBAAA;EAqTtC;EApTE;IAAoC,eAAA;EAuTtC;EAtTE;IAAoC,eAAA;EAyTtC;EAxTE;IAAoC,eAAA;EA2TtC;EA1TE;IACoC,WAAA;IACA,YAAA;EA4TtC;EA3TsC;IAAU,eAAA;EA8ThD;EA7TsC;IAAiB,eAAA;EAgUvD;AACF;AA5TA;EAEI;IAAoC,aAAA;EA8TtC;EA7TE;IAAoC,kBAAA;EAgUtC;EA/TE;IAAoC,eAAA;EAkUtC;EAjUE;IAAoC,eAAA;EAoUtC;EAnUE;IAAoC,eAAA;EAsUtC;EArUE;IACoC,WAAA;IACA,YAAA;EAuUtC;EAtUsC;IAAU,eAAA;EAyUhD;EAxUsC;IAAiB,eAAA;EA2UvD;AACF","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import 'variables';\n@import 'placeholders/fonts';\n@import 'placeholders/quickStyles';\n@import 'variables/breakpoints';\n@import 'placeholders/flexboxes';\n\n.rDNA-companyRankings             {\n                                    height: 100%;\n                                    width: 100%;\n\n  .decreasing                       { background-color: $rDNA-alert; }\n  .increasing                       { background-color: $rDNA-success; }\n  .noMovement                      { background-color: $rDNA-neutral; }\n  .newEntry                        { background-color: $accent-btn; }\n  .rDNA-contentWrapper              { padding: 0; }\n  .rDNA-movementTxt                 { margin-left: 10px; }\n\n  .rDNA-iconContainer               {\n                                      position: relative;\n                                      left: 15%;\n                                      width: 100%;\n                                      @extend %flex-row;\n                                      @extend %flex-jStart-aCenter;\n                                    }\n  .outer-circle                     {\n                                      border-radius: 50%;\n                                      color: #fff;\n                                      @extend %flex-row;\n                                      @extend %flex-jCenter-aCenter;\n\n                                      fa-icon { font-size: 28px; }\n                                    }\n  .rDNA-rankingCard                 {\n                                      justify-content: center;\n                                      @extend %max-HW-100;\n                                      box-shadow: none;\n                                      border-radius: 20px;\n                                    }\n  .rDNA-rankingsColHeader           {\n                                      @extend %font-18px-medium;\n                                      color: $inactive-text;\n                                    }\n  .rDNA-rankingEntry                {\n                                      @extend %font-20px-semi;\n                                      color: $dark-text;\n                                    }\n  .rDNA-rankingsTitle               {\n                                      @extend %font-34px-bold;\n                                      color: $dark-text;\n                                    }\n  .rDNA-txtCtrlWrapper              {\n                                      width: 100%;\n                                      .rDNA-txtCtrlWrapper {\n                                        align-items: center;\n                                      }\n                                    }\n}\n\n@media screen and (max-width: $breakpoint-sm-max) {\n  .rDNA-companyRankings             {\n                                        margin-bottom: 10px;\n    .rDNA-rankingCard                 { padding: 5px 15px; }\n    .rDNA-txtCtrlWrapper              { padding-left: 5px; }\n    .rDNA-rankingsColHeader           { font-size: 12px; }\n    .rDNA-rankingEntry                { font-size: 12px; }\n    .rDNA-rankingsTitle               { font-size: 18px; }\n    .outer-circle                     {\n                                        width: 15px;\n                                        height: 15px;\n                                        fa-icon { font-size: 15px; }\n                                        .icon-newEntry { font-size: 9px; }\n                                      }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  .rDNA-companyRankings             {\n    .rDNA-rankingCard                 { padding: 5px; }\n    .rDNA-movementTxt                 { margin-left: 5px; }\n    .rDNA-txtCtrlWrapper              { padding-left: 5px; }\n    .rDNA-rankingsColHeader           { font-size: 10px; }\n    .rDNA-rankingEntry                { font-size: 8px; }\n    .rDNA-rankingsTitle               { font-size: 18px; }\n    .outer-circle                     {\n                                        width: 15px;\n                                        height: 15px;\n                                        fa-icon { font-size: 15px; }\n                                        .icon-newEntry { font-size: 10px; }\n                                      }\n  }\n}\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  .rDNA-companyRankings             {\n    .rDNA-movementTxt                 { margin-left: 5px; }\n    .rDNA-rankingCard                 { padding: 10px; }\n    .rDNA-txtCtrlWrapper              { padding-left: 10px; }\n    .rDNA-rankingsColHeader           { font-size: 12px; }\n    .rDNA-rankingEntry                { font-size: 12px; }\n    .rDNA-rankingsTitle               { font-size: 20px; }\n    .outer-circle                     {\n                                        width: 17px;\n                                        height: 17px;\n                                        fa-icon { font-size: 16px; }\n                                        .icon-newEntry { font-size: 10px; }\n                                      }\n  }\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  .rDNA-companyRankings             {\n    .rDNA-rankingCard                 { padding: 15px; }\n    .rDNA-txtCtrlWrapper              { padding-left: 20px; }\n    .rDNA-rankingsColHeader           { font-size: 14px; }\n    .rDNA-rankingEntry                { font-size: 14px; }\n    .rDNA-rankingsTitle               { font-size: 20px; }\n    .outer-circle                     {\n                                        width: 20px;\n                                        height: 20px;\n                                        fa-icon { font-size: 20px; }\n                                        .icon-newEntry { font-size: 14px; }\n                                      }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  .rDNA-companyRankings             {\n    .rDNA-rankingCard                 { padding: 25px; }\n    .rDNA-txtCtrlWrapper              { padding-left: 50px; }\n    .rDNA-rankingsColHeader           { font-size: 18px; }\n    .rDNA-rankingEntry                { font-size: 20px; }\n    .rDNA-rankingsTitle               { font-size: 34px; }\n    .outer-circle                     {\n                                        width: 30px;\n                                        height: 30px;\n                                        fa-icon { font-size: 28px; }\n                                        .icon-newEntry { font-size: 18px; }\n                                      }\n  }\n}\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%max-HW-100 {\n  height: 100%;\n  width: 100%;\n}\n\n%full-screen-background-overlay {\n  display: flex;\n  flex-direction: column;\n  z-index: 98;\n  background-color: rgba(#e0e0e0, 0.5);\n  backdrop-filter: blur(4px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100dvw;\n  height: 100dvh;\n  align-items: center;\n  justify-content: center;\n}\n\n%white-background-raised-container {\n  height: fit-content;\n  max-height: 80dvh;\n  width: 70dvw;\n  border-radius: 50px;\n  background: white;\n  box-shadow: 20px 20px 20px #d9d9d9,\n  -20px -20px 20px #e0e0e0;\n  z-index: 99;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Base x-button style\n%x-button {\n  cursor: pointer;\n  z-index: 9999;\n\n  &:hover {\n    color: #333;\n  }\n}\n\n// Modifier: small\n%x-button--small {\n  position: absolute;\n  font-size: 0.75rem;\n  top: 0.5rem;\n  left: 14rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n// Modifier: large\n%x-button--large {\n  position: absolute;\n  font-size: 1.25rem;\n  top: 0.2rem;\n  left: 0.2rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n\n","\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
